export class Maestro_Provincias {
    codigo: string;
    descripcion: string;
    nombreMapa: string;
}